import Vue from 'vue'
import Router from 'vue-router'

//routing
import App from '@/App'
import Home from '@/views/Home'

Vue.use(Router)

export default new Router ({
    scrollBehavior: function(to, from, savedPosition) {
        if(savedPosition){
            return savedPosition
        } else {
            if (to.hash) {
                return {
                  selector: to.hash,
                  behavior: 'smooth',
                }
            }
        }
      },
    routes:[
        {
            path:'/',
            name:'App',
            component:App,
            redirect: '/it/'
        },
        {
            path:'/:lang/',
            name:'Home',
            component:Home,
            props: true,
            children:[
            {
                path:'cookie-policy',
                name:'cookie',
                component:  () => import('./views/Cookie.vue'),
            },
            {
                path:'privacy-policy',
                name:'privacy',
                component:  () => import('./views/Privacy.vue'),
            }
        ]},
    ]
})